import * as yup from 'yup'
import { ObjectSchema } from 'yup'
import { TYPE_REQUIRED, CANNOT_BE_BLANK } from 'constants/errors'
import { AnyDict } from 'interfaces'

const createFieldValidator = (field_name: string) =>
  yup.mixed()
    .when('$selectedFilters', (selectedFilters: string[] | undefined, schema: ObjectSchema<AnyDict>) => {
      if (selectedFilters && selectedFilters.includes(field_name)) {
        return schema.required(CANNOT_BE_BLANK)
      }
      return schema
    })

export default yup.object().shape({
  name: yup.string()
    .required(TYPE_REQUIRED)
    .matches(/[^\s]+/, TYPE_REQUIRED),
  peergroup: yup.object().shape({
    creditscore_range: createFieldValidator('creditscore_range'),
    income_range: createFieldValidator('income_range'),
    housing_type: createFieldValidator('housing_type'),
    age_range: createFieldValidator('age_range'),
    area_type: createFieldValidator('area_type'),
    location: createFieldValidator('location'),
  }),
})
